import { render, staticRenderFns } from "./PredefinedFormBuilder.vue?vue&type=template&id=37fb4bb1&scoped=true"
import script from "./PredefinedFormBuilder.vue?vue&type=script&lang=js"
export * from "./PredefinedFormBuilder.vue?vue&type=script&lang=js"
import style0 from "./PredefinedFormBuilder.vue?vue&type=style&index=0&id=37fb4bb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fb4bb1",
  null
  
)

export default component.exports